import axios from 'axios';

export const NAVIGATE = 'NAVIGATE';
export const SYNC = 'SYNC';
export const BUSY = 'BUSY';
export const BROKEN = 'BROKEN';
export const RESET = 'RESET';
export const INPUT = 'INPUT';
export const INIT = 'INIT';
export const UPDATE = 'UPDATE';
export const LOANPART = 'LOANPART';
export const ADD_LOANPART = 'ADD_LOANPART';
export const DELETE_LOANPART = 'DELETE_LOANPART';


export const sync = dispatch => (property, value) => {
  const fire = e => {
    dispatch({
      type: INPUT,
      payload: {
        [property]: e ? e.target.value : value,
      },
    });
  };
  if (typeof value === 'undefined') return fire;
  return fire();
};

// TODO: location and navigate are manditory when react-router-dom is v6
export const forward = dispatch => (recalculating, location = null, navigate = null) => {
  const action = { type: NAVIGATE, location, navigate };
  if (recalculating) action.index = recalculating;
  else action.delta = 1;
  return e => {
    e.preventDefault();
    dispatch(action);
  };
};

export const dispatchMapper = dispatch => ({
  dispatch,
  sync: sync(dispatch),
  forward: forward(dispatch)
});

export function dispatchWithRequest(property, value, request, path, callback, sources = {}) {
  return (dispatch, getState) => {
    dispatch({
      type: INPUT,
      payload: { [property]: value },
    });
    const state = getState();
    if (sources[request]) sources[request].abort();
    sources[request] = new AbortController();
    const data = state.input;
    axios({
      method: 'post',
      url: request,
      data,
      signal: sources[request].signal,
    })
      .then(res => {
        if (res.data && res.data.length === 0) res.data = {};
        if (path) {
          dispatch({ type: SYNC, payload: { [path]: res.data } });
        } else {
          dispatch({ type: SYNC, payload: res.data });
        }
        if (callback) callback(res.data);
      })
      .catch(error => {
        if (axios.isCancel(error)) return;
        window.console.error(error);
        error.response = error.response || {};
        const { errors } = error.response.data || {};
        dispatch({ type: SYNC, syncing: false, payload: errors ? { errors } : {} });
      });
  };
}
